import { Component } from "@angular/core";
import { SHARED } from "@apps/patient-core/src/app/shared";

@Component({
  selector: "dentr-privacy-policy-au",
  templateUrl: "./privacy-policy-au.component.html",
  standalone: true,
  imports: [SHARED],
})
export class PrivacyPolicyAUComponent {}
